import { render, staticRenderFns } from "./NoteTypeForm.vue?vue&type=template&id=14c6bc16&"
import script from "./NoteTypeForm.vue?vue&type=script&lang=js&"
export * from "./NoteTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./NoteTypeForm.vue?vue&type=style&index=0&id=14c6bc16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports